<template>
    <v-btn block color="green white--text text-capitalize subtitle-1 mt-2" @click="signUpWithGoogle">
        <v-icon dark left>mdi-google</v-icon> Login using gmail
    </v-btn>
</template>
<script>
import { SIGN_UP_USER_OTHERS } from "@/store/actions.type"
export default {
    methods: {
        signUpWithGoogle() {
            this.$store.dispatch(SIGN_UP_USER_OTHERS, {
              type: 'google',
            })
        }
    }
}
</script>